import isMobile from "./isMobile";

export default function isBrowser() {
  return !isMobile()
}

export const isWindows7 = () => {
  var ua = navigator.userAgent;
  return !!ua.match(/Win(dows )?NT 6\.1/);
};

export const isIE = () => !!window.document.documentMode
